exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#agenda-appointment-history .modal-dialog{max-width:960px!important}", ""]);

// exports
